import moment from 'moment';
import { DictionaryContextType } from '../dictionaries/context/DictionaryContextTypes';
import { Negotiation, NegotiationOption, OutDebt, OutDebtFieldsFragment } from '../generated/graphql';
import thousandSeparator from './thousandSeparator';

type ContentInstallmentsPlanBbvaType = {
  gT: (key: string, context?: DictionaryContextType) => string,
  outDebt: OutDebt,
  negOption?: NegotiationOption,
  outDebts?: Array<OutDebtFieldsFragment>
};

enum MovistarMoneyKeys {
  General = 'alert_paymentAlert_content_totalPayment',
  NoMovistarInvoice = 'alert_paymentAlert_content_totalPayment_no_movistar_invoice',
  MovistarInvoice = 'alert_paymentAlert_content_totalPayment_movistar_invoice',
  GeneralAcpkInvoice = 'alert_paymentAlert_content_penaltyPortfolioPaymentAgreement_movistar_invoice',
  GeneralAcpkNoInvoice = 'alert_paymentAlert_content_penaltyPortfolioPaymentAgreement_no_movistar_invoice',
}

export const getContentTotalPaymentMovistarMoney = (props : ContentInstallmentsPlanBbvaType) => {
  const { gT, outDebt } = props;
  const { productNumber = '', negotiation, bank } = outDebt;
  const { alternative, negotiationOption } = negotiation as Negotiation;
  const negPaymentDate = moment(negotiationOption?.settings?.maxPaymentDate).isValid() ? moment(negotiationOption?.settings?.maxPaymentDate).format('LL') : '';
  const keys = [ gT(MovistarMoneyKeys.General, {
    productNumber: `${productNumber}`,
    bank,
    monthlyPayment: thousandSeparator(alternative.value),
    negPaymentDate,
  }) ];
  if (outDebt.extra?.movistarInvoice === 'No') {
    keys.push(gT(MovistarMoneyKeys.NoMovistarInvoice));
  }
  if (outDebt.extra?.movistarInvoice === 'Si') {
    keys.push(gT(MovistarMoneyKeys.MovistarInvoice));
  }
  return keys.join('\n');
};

export const getContentKeysAcpkMovistarMoney = (props : ContentInstallmentsPlanBbvaType) => {
  const { outDebt } = props;
  if (outDebt.extra?.movistarInvoice === 'No') {
    return MovistarMoneyKeys.GeneralAcpkNoInvoice;
  }
  if (outDebt.extra?.movistarInvoice === 'Si') {
    return MovistarMoneyKeys.GeneralAcpkInvoice;
  }
  return MovistarMoneyKeys.GeneralAcpkNoInvoice;
};
